import React from 'react';
import "./styles.css";
import { Link, DisabledPrompt, useRoute, useParams, Branding } from "@bcm-dev/bcms-vite";
import ControlView from 'components/shared/views/BaseRowView/components/ControlView';

/**
 * @function ControlsView
 * @param {DECIMAL} transactionAmount - This is the transaction amount for the spend limits.
 * @param {DECIMAL} monthlyAmount - This is the monthly amount for the spend limits.
 * @return {React.Component}
 * @exported true
 * @description The main component for ControlsView
 * @example
 * <ControlsView transactionAmount="100.87" monthlyAmount="6.40" />
 */
export default function ControlsView(props) {
  const transactionAmount = props.transactionAmount ?? "100.00";
  const monthlyAmount = props.monthlyAmount ?? "1,500.00";

  const navigate = useRoute();
  const cardID = useParams().cardID ?? "0";

  const transactionRoute = evt => navigate(`/home/transactioncontrols/${ cardID }`);
  const locationRoute = evt => navigate(`/home/locationcontrols/${ cardID }`);
  const merchantRoute = evt => navigate(`/home/merchantcontrols/${ cardID }`);
  const spendRoute = evt => navigate(`/home/spendcontrols/${ cardID }`);
  
  return (
    <div className="controls-view">
      <Branding id="controls_locations_chw23" value="true">
        <ControlView 
          leftIcon="MapLocationIcon" 
          controlText="Locations" 
          controlSubText={
            <>
              My Regions
              <Branding id="locationcontrols_international_chw23" value="true">, International</Branding>
            </>
          } 
          onClick={ locationRoute } 
          dataPoint="control_regions"/>
      </Branding>

      <ControlView leftIcon="ShopIcon" controlText="Merchant Types" controlSubText="Department Store, Entertainment, Gas Station, Grocery, Hous..." onClick={ merchantRoute } dataPoint="control_merchants" />
      <ControlView leftIcon="TagIcon" controlText="Transaction Types" controlSubText="In-Store, Online / eCommerce, Recurring / Autopay, ATM, Other" onClick={ transactionRoute } dataPoint="control_transactions"/>

      <Branding id="monthly_spendlimit_chw23" value="true">
        <ControlView leftIcon="MeterLimitsIcon" controlText="Spend Limits" controlSubText={"Transaction: $"+transactionAmount+", Monthly: $"+monthlyAmount} onClick={ spendRoute } dataPoint="control_spend"/>
      </Branding>

      <Branding id="monthly_spendlimit_chw23" value="false">
        <ControlView leftIcon="MeterLimitsIcon" controlText="Spend Limits" controlSubText={`Transaction: $${ transactionAmount }`} onClick={ spendRoute } dataPoint="control_spend"/>
      </Branding>

      <DisabledPrompt>
        <Link className="tell-me-more">Tell me more</Link>
      </DisabledPrompt>
    </div>
  )
}
